import { render, staticRenderFns } from "./TableActions.vue?vue&type=template&id=13f88689&scoped=true"
import script from "./TableActions.vue?vue&type=script&lang=js"
export * from "./TableActions.vue?vue&type=script&lang=js"
import style0 from "./TableActions.vue?vue&type=style&index=0&id=13f88689&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f88689",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/pages/extranet/TableActions.vue
// module id = 167
// module chunks = 31